module.exports = __webpack_public_path__ + "img/twitter.37e33b32.svg";